import { OrderItem } from "../models/IOrders";
import { configWithUserToken } from "./config";

export const getOrderHistory = (startDate: string, endDate: string) => {
  return configWithUserToken.get<OrderItem[]>(
    `Order/History/Me`,
    { params: { startDate, endDate } }
  );
};
